export function getAll() {
  return [
    {
      value: 0,
      name: "Format1",
      text: "格式一",
    },
    {
      value: 1,
      name: "Format2",
      text: "格式二(A4)",
    },
    {
      value: 2,
      name: "Format3",
      text: "格式二(中一刀)",
    },
    {
      value: 3,
      name: "Format4",
      text: "格式一(A4)",
    },
  ];
}
